"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _image = require("@site/pattern-library-core/image");
var _index = _interopRequireDefault(require("../../../elements/other/lazy-video/index.js"));
var _index2 = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _playButton = _interopRequireDefault(require("../video-lightbox/play-button.js"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
/* eslint-disable complexity */

const GalleryItemContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "GalleryItemContainer",
  class: "pl-g1r1u35h"
});
const ItemInner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ItemInner",
  class: "pl-ir107wj"
});
const LazyImage = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "LazyImage",
  class: "pl-l7uk5cw"
});
const VideoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "VideoContainer",
  class: "pl-v1s35a42"
});
const Video = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "Video",
  class: "pl-vmmejzr"
});
const OverlayContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "OverlayContent",
  class: "pl-ozkzxpa"
});
const Effect = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Effect",
  class: "pl-e6kr1vb"
});

/**
 * GalleryItem Component
 *
 * @param {Object} props props
 * @param {string} props.id id for the item
 * @param {string} props.partial Optional partial data attribute
 * @param {boolean} props.invert Flag to determine if the item should be inverted
 * @param {boolean} props.inView Flag to determine if the item is in view
 * @param {Object} props.portrait Portrait image object
 * @param {Object} props.landscape Landscape image object
 * @param {string} props.thumbnailDesktop Thumbnail image url for desktop
 * @param {string} props.thumbnailMobile Thumbnail image url for mobile
 * @param {string} props.introUrl Intro video url
 * @param {string} props.introUrlWebm Intro video webm url
 * @param {string} props.introUrlLaptop Intro video laptop url
 * @param {string} props.introUrlLaptopWebm Intro video laptop webm url
 * @param {boolean} props.preload Flag to determine if the video should be preloaded
 * @param {string} props.youTubeId YouTube video id
 * @param {string} props.lightboxUrl Lightbox video url
 * @param {Object} props.headlineProps Headline lockup props
 * @param {Function} props.handlePlay Function to handle play event
 * @param {boolean} props.pause Flag to determine if the video should be paused
 * @param {boolean} props.isCenteredIndex Flag to determine if the item is centered
 * @param {number} props.index Index of the item
 * @returns {React.ReactElement} GalleryItem Component
 * @public
 */
function GalleryItem({
  id,
  partial,
  invert,
  inView,
  portrait,
  landscape,
  thumbnailDesktop,
  thumbnailMobile,
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  preload,
  youTubeId,
  lightboxUrl,
  headlineProps,
  handlePlay,
  pause,
  isCenteredIndex,
  index
}) {
  const backgroundImages = {
    portrait: portrait?.url,
    landscape: landscape?.url
  };
  const videoSource = {
    fallback: thumbnailDesktop,
    laptop: introUrlLaptop,
    laptopWebm: introUrlLaptopWebm,
    fallbackMobile: thumbnailMobile,
    base: introUrl,
    baseWebm: introUrlWebm
  };
  return /*#__PURE__*/_react.default.createElement(GalleryItemContainer, {
    "data-cy": `gallery-item-${index}`,
    "data-partial": partial || (invert ? 'dark1' : ''),
    className: inView && 'active-item'
  }, /*#__PURE__*/_react.default.createElement(ItemInner, null, /*#__PURE__*/_react.default.createElement(Effect, {
    className: !isCenteredIndex ? '' : 'not-centered'
  }), /*#__PURE__*/_react.default.createElement(OverlayContent, null, /*#__PURE__*/_react.default.createElement(_index2.default, (0, _extends2.default)({
    textAlign: "center",
    ctaFlexDirection: "row",
    ctas: (lightboxUrl || youTubeId) && /*#__PURE__*/_react.default.createElement(_playButton.default, {
      id: `${id}-${index}`,
      handlePlay: handlePlay
    }),
    headlineSize: "h4"
  }, headlineProps))), (portrait || landscape) && /*#__PURE__*/_react.default.createElement(LazyImage, (0, _extends2.default)({}, backgroundImages, {
    imgLoading: "lazy",
    breakOn: "mobile"
  })), introUrl && introUrlLaptop && /*#__PURE__*/_react.default.createElement(VideoContainer, null, /*#__PURE__*/_react.default.createElement(Video, {
    videoSource: videoSource,
    preload: preload || 'metadata',
    loop: true,
    autoPlay: true,
    pause: pause
  }))));
}
var _default = exports.default = GalleryItem;
GalleryItem.propTypes = {
  id: _propTypes.default.string,
  partial: _propTypes.default.string,
  invert: _propTypes.default.bool,
  inView: _propTypes.default.bool,
  portrait: _propTypes.default.object,
  landscape: _propTypes.default.object,
  thumbnailDesktop: _propTypes.default.string,
  thumbnailMobile: _propTypes.default.string,
  introUrl: _propTypes.default.string,
  introUrlWebm: _propTypes.default.string,
  introUrlLaptop: _propTypes.default.string,
  introUrlLaptopWebm: _propTypes.default.string,
  preload: _propTypes.default.bool,
  youTubeId: _propTypes.default.string,
  lightboxUrl: _propTypes.default.string,
  headlineProps: _propTypes.default.object,
  handlePlay: _propTypes.default.func,
  pause: _propTypes.default.bool,
  isCenteredIndex: _propTypes.default.bool,
  index: _propTypes.default.number
};